/**
 * Modal for adding projects by GitHub repo URL
 * Story 287: OAuth for collaborator repos
 * Story 382: Unified repo access flow with auto-recheck on tab return
 */

import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { RepoAccessResolver } from './RepoAccessResolver';
import './AddProjectModal.css';

interface AddProjectModalProps {
  onClose: () => void;
  onSuccess?: () => void;
}

export function AddProjectModal({ onClose, onSuccess }: AddProjectModalProps) {
  const navigate = useNavigate();

  const handleBackdropClick = useCallback(
    (e: React.MouseEvent) => {
      if (e.target === e.currentTarget) {
        onClose();
      }
    },
    [onClose]
  );

  const handleSuccess = useCallback(
    (project: { slug: string }) => {
      onSuccess?.();
      onClose();
      // Story 382 task 17: same URL as Dashboard.handleSelectProject; /project/<slug> is not a route
      navigate(`/workspace?project=${encodeURIComponent(project.slug)}`);
    },
    [onSuccess, onClose, navigate]
  );

  return (
    <div className="add-project-modal__backdrop" onClick={handleBackdropClick}>
      <div className="add-project-modal" role="dialog" aria-labelledby="add-project-title">
        <RepoAccessResolver
          mode="add"
          onSuccess={handleSuccess}
          onClose={onClose}
        />
      </div>
    </div>
  );
}
